import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const dutyExportContract = c.router({
  updateTaricDutyExport: {
    method: 'POST',
    path: '/external-api/update-taric-duty-export',
    body: c.noBody(),
    contentType: 'multipart/form-data',
    responses: { 200: z.boolean() },
  },
  publishTaricDutyExport: {
    method: 'POST',
    path: '/external-api/publish-taric-duty-export',
    body: c.noBody(),
    responses: { 200: z.boolean() },
  },
});
